module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.currentQuestion.data.type === "verbatim") ? _c('verbatim', {
    ref: "verbatim",
    on: {
      "newAnswer": _vm.newAnswerChanged,
      "canValidate": _vm.canValidateChanged
    }
  }) : (_vm.currentQuestion.data.type === "multiChoice") ? _c('multi-choice', {
    ref: "multiChoice",
    on: {
      "newAnswer": _vm.newAnswerChanged,
      "canValidate": _vm.canValidateChanged
    }
  }) : (_vm.currentQuestion.data.type === "singleChoice") ? _c('single-choice', {
    ref: "singleChoice",
    on: {
      "newAnswer": _vm.newAnswerChanged,
      "canValidate": _vm.canValidateChanged
    }
  }) : (_vm.currentQuestion.data.type === "order") ? _c('order', {
    ref: "order",
    on: {
      "newAnswer": _vm.newAnswerChanged,
      "canValidate": _vm.canValidateChanged
    }
  }) : _vm._e(), _vm._v(" "), (_vm.canValidate) ? _c('v-btn', {
    staticClass: "answers-buttom elevation-0 deep-purple accent-2 white--text",
    nativeOn: {
      "click": function($event) {
        _vm.next($event)
      }
    }
  }, [_vm._v("\n    Continuer\n  ")]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-34dfa8bc","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/additional/Question.vue
// module id = 319
// module chunks = 1